module.exports = __webpack_public_path__ + "static/img/POWERPAOLA.0b2288f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/POWERPAOLA.jpg
// module id = 4/gc
// module chunks = 1